/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/spaManager/routerProvider" />
let routerInstance: any = null;

export function setRouter(router: any) {
    routerInstance = router;
}

export function getRouter() {
    return routerInstance;
}